export default values => (values
    ? `    <div style="display: flex; height: 100%; align-items: center;">
        <div>#${values.taskId} Создано ${values.dateCreate} Обновлено ${values.dateUpdate} ${values.stateTask}</div>
    </div>`
    : `<div style="display: flex; height: 100%; align-items: center;">
    <div>#_____ Создано '__.__.____ __:__:__' Обновлено '__.__.____ __:__:__' Не закрыта</div>
</div>`);
